export default __webpack_public_path__ + "static/media/house-rules.dcff6722.png";